import { getMyOrganizations } from '@/features/organizations/api/get-my-organizations'
import { MY_ORGANIZATIONS_QUERY_KEY } from '@/features/organizations/queries/useMyOrganizations'
import { queryClient } from '@/lib/api/queryClient'
import { useWorkspaceStore } from '@/stores/workspace'

/**
 * Makes sure the user's organizations (and their permissions) are in the workspace store. The
 * router guard awaits this so a hard refresh on a permission-gated page doesn't bounce.
 */
export async function ensureMyOrganizations(): Promise<void> {
  const workspace = useWorkspaceStore()
  if (workspace.isLoaded) return

  workspace.setOrganizations(
    await queryClient.ensureQueryData({
      queryKey: MY_ORGANIZATIONS_QUERY_KEY,
      queryFn: getMyOrganizations,
    }),
  )
}
